import React from 'react';
import FieldSelectAutoComplete from '../../configuration/fields/FieldSelectAutoComplete';

export default class IndexTableFiltersPanelSelect extends React.Component {
    constructor(props) {
        super(props)
    }

    static getInputStateValue = (filter) => {

        if (filter.selectedItem !== null && filter.selectedItem.value != null) {
            return {
                text: filter.selectedItem.text,
                value: filter.selectedItem.value,
                type: filter.meta.type,

            }
        }
        return null;
    }

    onChange = item => {
        this.props.onChange({
            text: this.props.prop.items.find(x => x.value === item).text,
            value: item
        }, true)
    }

    render() {

        return (
            <div className="filters-panel-input">
                <span title={this.props.label}>{this.props.label}</span>
                <span>
                    <FieldSelectAutoComplete
                        items={this.props.prop.items}
                        value={this.props.value}
                        forceReadable={true}
                        forceNonPortal={true}
                        onChange={this.onChange}
                    />
                </span>
            </div>
        )
    }
}